export default __webpack_public_path__ + "assets/wizard-topic-94e3d14c80156a94bb4e52ced29342a2.svg";